import $ from "./jquery-shim.js";
import "owl.carousel";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";

var defaultOptions = {
  selector: ".owl-carousel",
};

export default class OwlCarousel {
  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(defaultOptions, options);
    this.init();
  }

  /**
   * 初期化
   */
  init() {
    // ターゲットを取得する
    this.targetAll = $(this.options.selector);

    // ターゲットが存在しない場合は実行しない
    if (!this.targetAll.length) {
      return false;
    }

    // 実行する
    this.run();
  }

  /**
   * 実行する
   */

  run() {
    // const gsap = this.options.gsap;

    //->スライダー
    this.targetAll.imagesLoaded(function () {
      const slidesNum = $(".c-main-visual__image").length;
      $(".c-main-visual__index-total").text("0" + slidesNum);
      $(".c-main-visual__index-current").text("01");

      var mainVisualOwl = $(".c-main-visual__slider");

      mainVisualOwl.owlCarousel({
        items: 1,
        margin: 0,
        dots: false,
        loop: true,
        nav: false,
        onInitialized: function () {
          // gsap.animate
        },
        autoplayHoverPause: true,
        autoplay: false,
        smartSpeed: 500,
        autoWidth: false,
        autoHeight: false,
        center: true,
        animateOut: "fadeOut",
        animateIn: "fadeIn",
        mouseDrag: false,
        touchDrag: false,
        navText: [
          '<img src="/wp-content/themes/musashino-html/dist/assets/images/icon-slider-prev.svg" />',
          '<img src="/wp-content/themes/musashino-html/dist/assets/images/icon-slider-next.svg" />',
        ],
      });

      mainVisualOwl.on("changed.owl.carousel", function (e) {
        $(".c-main-visual__index-current").text("0" + (e.item.index - 1));
      });

      var time = 5;
      var $bar, $slick, isPause, tick, percentTime;

      $bar = $(".c-main-visual__progress-bar");

      function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        isPause = false;
        tick = setInterval(interval, 10);
      }

      function interval() {
        if (isPause === false) {
          percentTime += 1 / (time + 0.1);
          $bar.css({
            width: percentTime + "%",
          });
          if (percentTime >= 100) {
            mainVisualOwl.trigger("next.owl.carousel");
            startProgressbar();
          }
        }
      }

      function resetProgressbar() {
        $bar.css({
          width: 0 + "%",
        });
        clearTimeout(tick);
      }

      startProgressbar();
    });

    //->カード_カルーセル
    this.targetAll.imagesLoaded(function () {
      if ($(".js-card-slider.owl-carousel").length <= 0) {
        return;
      }

      if ($(".js-card-slide").length <= 2) {
        $(".js-card-slider").removeClass("owl-carousel");
        return;
      }

      $(".js-card-slider").owlCarousel({
        margin: 0,
        dots: false,
        loop: true,
        nav: true,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: false,
        autoHeight: false,
        center: true,
        speed: 400,
        navText: [
          '<img src="/wp-content/themes/musashino-html/dist/assets/images/icon-slider-prev.svg" />',
          '<img src="/wp-content/themes/musashino-html/dist/assets/images/icon-slider-next.svg" />',
        ],
        responsive: {
          // breakpoint from 0 up
          0: {
            items: 1,
          },
          // breakpoint from 750 up
          750: {
            items: 3,
          },
        },
      });
    });
  }
}
